import React, { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import useOutsideAlerter from "../../hooks/useOutsideAlerter";
import "./dropdown.css";

const Dropdown = ({ data, onChange, initialSelectedItem }) => {

  const [isOpen, setOpen] = useState(false);
  const [items, setItem] = useState(data);
  const [selectedItem, setSelectedItem] = useState(initialSelectedItem);

  const dropDownRef = useRef(null)

  useEffect(() => {
    setSelectedItem(initialSelectedItem)
  }, [initialSelectedItem])

  const toggleDropdown = () => setOpen(!isOpen);

  const handleClose = () => setOpen(false)
  useOutsideAlerter(dropDownRef, handleClose)

  const handleItemClick = (id) => {
    selectedItem == id ? setSelectedItem(null) : setSelectedItem(id);
    toggleDropdown()
    onChange(id)
  };
  
  return (
    <div className="dropdown" ref={dropDownRef} > 
      <div className="dropdown-header" onClick={toggleDropdown}>
        {selectedItem ? items.find((item) => item.id == selectedItem).value : "None"}
        {/* <i className={`fa fa-chevron-right icon ${isOpen && "open"}`}></i> */}
        <img src="/assets/icons/down.svg" className={`fa fa-chevron-right icon ${isOpen && "open"}`} />
      </div>
      <div className={`dropdown-body ${isOpen && "open"}`}>
        {items.map((item, idx) => (
          <div key={idx} className="dropdown-item" onClick={(e) => handleItemClick(e.target.id)} id={item.id}>
            <span className={`dropdown-item-dot ${item.id == selectedItem && "selected"}`}>• </span>
            {item.value}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dropdown;
